import { useQuery } from '@tanstack/react-query'
import { createFileRoute, Link } from '@tanstack/react-router'
import { useState } from 'react'
import { EmployeeSummary, employeesQueryOptions } from '@/entities/employee'
import { Checkbox } from '@/shared/ui/checkbox'
import { EmptyState } from '@/shared/ui/empty-state'
import { PageHeader } from '@/shared/ui/page-header'

export const Route = createFileRoute('/_app/employees/')({
  component: EmployeesPage,
})

const SKELETON_ROWS = ['s1', 's2', 's3']

function ListSkeleton() {
  return (
    <div className="flex flex-col gap-2" aria-hidden>
      {SKELETON_ROWS.map((s) => (
        <div key={s} className="h-16 animate-pulse rounded-card bg-bg-elevated" />
      ))}
    </div>
  )
}

function EmployeesPage() {
  const [activeOnly, setActiveOnly] = useState(true)

  const employees = useQuery(employeesQueryOptions({ activeOnly }))
  const items = employees.data ?? []

  return (
    <>
      <PageHeader
        title="Сотрудники"
        description="Профили из Authentik. Хаб владеет отделом и активностью доступа."
      />

      <div className="mb-4 flex flex-wrap items-center gap-2">
        <Checkbox
          className="rounded-pill bg-bg-surface px-3.5 py-2 hover:bg-bg-raised"
          checked={activeOnly}
          onChange={(e) => setActiveOnly(e.target.checked)}
          label="Только активные"
        />
      </div>

      {employees.isPending ? (
        <ListSkeleton />
      ) : items.length === 0 ? (
        <EmptyState
          title="Сотрудников нет"
          description="Профили появляются при первом входе через SSO."
        />
      ) : (
        <ul className="flex flex-col gap-2">
          {items.map((employee) => (
            <li key={employee.id}>
              <Link to="/employees/$employeeId" params={{ employeeId: employee.id }}>
                <EmployeeSummary employee={employee} />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </>
  )
}
